import fc from "@/firebaseConfig";
import firebase from "firebase/app";
import getDocumentTypeKey from "../../libs/getDocumentTypeKey";
import router from "@/router";
import gql from "graphql-tag";
import moment from "moment";
import _ from "lodash";
import { subscribeWithHealth } from "@/libs/firestoreListener";

// Utility Functions
const removeDuplicatesWithSameId = (inputArray) => {
  const idSet = new Set();
  return inputArray.filter(item => {
    const itemId = item.documentID;
    if (!idSet.has(itemId)) {
      idSet.add(itemId);
      return true;
    }
    return false;
  });
};

function sortByField(arr, field, order) {
  const multiplier = order === "desc" ? -1 : 1;
  return [...arr].sort((a, b) => {
    const aValue = a[field];
    const bValue = b[field];
    return typeof aValue === "string" && typeof bValue === "string"
      ? multiplier * aValue.localeCompare(bValue)
      : multiplier * (aValue - bValue);
  });
}

const isNumeric = (input) => /^[0-9]+$/.test(input);

const adjustDate = (inputDateString) => {
  const inputDate = new Date(inputDateString);
  const localOffset = inputDate.getTimezoneOffset() * 60000;
  return new Date(inputDate.getTime() - localOffset);
};

const removeDuplicatesAndEmptyStrings = (arr) => {
  const uniqueValues = new Set();
  return arr.filter(item => {
    if (item === '') return false;
    if (!uniqueValues.has(item)) {
      uniqueValues.add(item);
      return true;
    }
    return false;
  });
};

const getFormatedKeywordList = (_keyword, _prefixes) => {
  _prefixes = removeDuplicatesAndEmptyStrings(_prefixes);
  _keyword = _keyword.toUpperCase();
  return [
    _keyword,
    ...(_prefixes.some(prefix => _keyword.startsWith(prefix))
      ? []
      : _prefixes.map(prefix => prefix + _keyword)),
  ];
};

const getDateBefore = (inputDateString) => {
  const millisecondsBefore = 12 * 60 * 60 * 1000;
  const inputDate = new Date(inputDateString);
  return new Date(inputDate.getTime() - millisecondsBefore);
};

// Vuex Store Configuration
export default {
  namespaced: true,
  state: {
    list: [],
    listOrigin: [],
    searchField: "documentID",
    transactionStatus: "",
    page: 1,
    loading: false,
    count: 0,
    keyword: "",
    fromDate: "",
    toDate: "",
    emptyList: true,
    stackPage: {},
    currentPageAlgolia: 0,
    docList: [],
    timePeriodsList: [],
    timePeriodsYear: [],
    branchList: [],
    taxTimePeriods: [],
    taxWHBranch: [],
    taxCodeSetting: [],
    docsThaiSm: [],
    summaryReport: {},
    orderBySelect: { key: "docDate", value: "desc" },
    valueFilterList: ["@DownloadedXml", "not-download", "cancelled"],
    selectedList: [],
    summaryAll: null,
    filterData: {
      payeeName: "",
      branchID: "",
      taxType: "",
      fromNo: "",
      toNo: "",
      fromDate: "",
      toDate: "",
      nsDocID: "",
        fillingStatus: "",
    },
    showPaginationTemplate: true,
    mThaiSmartTaxDocListUnsubscribeObject: null,
    mThaiSmartTaxSummaryAllUnsubscribeObject: null,
  },
  mutations: {
    setBranchList(state, val) { state.branchList = val; },
    setLoading(state, val) { state.loading = val; },
    setFromDate(state, val) { state.fromDate = val; },
    setToDate(state, val) { state.toDate = val; },
    setSearchField(state, val) { state.searchField = val; },
    setCompaniesDocs(state, val) { state.list = removeDuplicatesWithSameId(val); },
    setPage(state, val) { state.page = val; },
    setKeyword(state, val) { state.keyword = val; },
    setListOrigin(state, val) { state.listOrigin = val; },
    setEmptyList(state, val) { state.emptyList = val; },
    setStackPage(state, val) { state.stackPage = val; },
    setCurrentPageAlgolia(state, val) { state.currentPageAlgolia = val; },
    setDocList(state, val) { state.docList = val; },
    setSummaryReport(state, val) { state.summaryReport = val; },
    setOrderBySelect(state, val) { state.orderBySelect = val; },
    setValueFilterList(state, val) { state.valueFilterList = val; },
    setSelectedList(state, val) { state.selectedList = val; },
    setSummaryAll(state, val) { state.summaryAll = val; },
    setShowPaginationTemplate(state, val) { state.showPaginationTemplate = val; },
    setTimePeriods(state, val) { state.timePeriodsList = val; },
    setTimePeriodsYear(state, val) { state.timePeriodsYear = val; },
    setTaxWHBranch(state, val) { state.taxWHBranch = val; },
    settaxTimePeriods(state, val) { state.taxTimePeriods = val; },
    setFilterData(state, val) { state.filterData = val; },
    setDocsThaiSm(state , docThaiSm) { state.docsThaiSm = docThaiSm},
    setTransactionStatus(state, val) { state.transactionStatus = val; },
  },
  actions: {



    updateDocs({ commit }, val) { commit("setCompaniesDocs", val); },
    getDocumentType() {
      const documentType = router.currentRoute.name.split(".");
      return documentType.length > 2 ? documentType[documentType.length - 1] : "";
    },
    setLoading({ commit }, val) { commit("setLoading", val); },

    setFromDate({ commit }, val) { commit("setFromDate", val); },
    setToDate({ commit }, val) { commit("setToDate", val); },
    setSearchField({ commit }, val) { commit("setSearchField", val); },
    setTransactionStatus({ commit }, val) { commit("setTransactionStatus", val); },
    async getList({ rootState, commit, dispatch }, { id, isNextPage }) {
      commit("setLoading", true);

      const pageLimitForKeyword = 250;
      let pageLimit = localStorage.getItem("pageLimit");
      pageLimit = pageLimit === "auto" ? parseInt(localStorage.getItem("pageLimitAuto")) || 10 : parseInt(pageLimit) || 10;
      const documentType = await dispatch("getDocumentType");


      let query = fc.companies.doc(id).collection("DocsThaiSmartTax");

      query = query.where("@DocType", "==","wh");
      query = query.where("taxWHCode", "==", "3");
      if (rootState.thaismartTaxPND54.transactionStatus !== "") {
        query = query.where("transactionStatus", "==", rootState.thaismartTaxPND54.transactionStatus).orderBy("transactionStatus", "asc");
      }else{
        query = query.where("transactionStatus", "not-in", ['Cancel']).orderBy("transactionStatus", "asc");
      }
      const { searchField, orderBySelect, valueFilterList, page } = this.state.thaismartTaxPND54;

      // debugger
      const payeeName = this.state.thaismartTaxPND54.filterData.payeeName;
      commit("setKeyword", payeeName);
      const keyword = this.state.thaismartTaxPND54.filterData.payeeName;
      const nsDocID = this.state.thaismartTaxPND54.filterData.nsDocID;
      const branchID = this.state.thaismartTaxPND54.filterData.branchID;
      const taxType = this.state.thaismartTaxPND54.filterData.taxType;
      const fromNo = this.state.thaismartTaxPND54.filterData.fromNo;
      const toNo = this.state.thaismartTaxPND54.filterData.toNo;
      const fromDate = this.state.thaismartTaxPND54.filterData.fromDate;
      commit("setFromDate", fromDate);
        const toDate = this.state.thaismartTaxPND54.filterData.toDate;
        commit("setToDate", toDate);
        const fillingStatus = this.state.thaismartTaxPND54.filterData.fillingStatus;
      if (payeeName) {
        const _keyword = this.state.thaismartTaxPND54.filterData.payeeName
        query = query.where("payeeName", "==", _keyword)
            // .where("payeeName", "<=", _keyword + "\uf8ff")
            .orderBy("payeeName", "asc")
            .limit(pageLimitForKeyword);
      }
      if (nsDocID) {
        const _keyword = this.state.thaismartTaxPND54.filterData.nsDocID
        query = query.where("internalDocument", "==", _keyword)
            .orderBy("internalDocument", "asc")
            .limit(pageLimitForKeyword);
      }


      if (branchID) {
        const _keyword = this.state.thaismartTaxPND54.filterData.branchID;
        if (!Number.isNaN(Number.parseInt(_keyword))) {
          query = query.where("subsidiariesBranch", "==", _keyword)
              .limit(pageLimitForKeyword);
        }
      }

      if (taxType) {
        let _keyword = this.state.thaismartTaxPND54.filterData.taxType;
        if (_keyword.includes(".53")) {
          _keyword = "1";
        } else if (_keyword.includes(".3")) {
          _keyword = "2";
        }
        if (_keyword === "1" || _keyword === "2") {
          query = query.where("taxWHCode", "==", _keyword)
              .limit(pageLimitForKeyword);
        }
      }

      // if(!(Object.values(this.state.thaismartTaxPND54).every(value => !value))) {
      //   if (orderBySelect.key && orderBySelect.key !== "ID" && !keyword && !fromDate && !toDate) {
      //     query = query.orderBy(new firebase.firestore.FieldPath(orderBySelect.key), orderBySelect.value);
      //   }
      // }


      if (this.state.mThaiSmartTaxDocListUnsubscribeObject) {
        this.state.mThaiSmartTaxDocListUnsubscribeObject();
      }
      const keepOnlyNumbers = (inputString) => {
        const output = Number.parseInt(inputString.replace(/\D/g, ''))
        return typeof output === 'number' && !Number.isNaN(output) ? output : 0;
      }
      this.state.mThaiSmartTaxDocListUnsubscribeObject = subscribeWithHealth(query, (documents) => {
        let documentsArray = [];
        if (documents.size !== 0) {
          documentsArray = documents.docs.map(doc =>{
            let document = doc.data();
            document.id = doc.id;
            return document;
          })
          if (toDate && fromDate ) {
            if (toDate === fromDate) {
              documentsArray = documentsArray.filter(item => {
                return moment(item.docDate.toDate()).isSame(moment(fromDate, "YYYY-MM-DD"), "dates");
              });
            } else {
              const fromD = moment(fromDate, "YYYY-MM-DD");
              const toD = moment(toDate, "YYYY-MM-DD").add(1, "day");
              documentsArray = documentsArray.filter(item => moment( item.docDate.toDate()).isBetween(fromD, toD));
            }
          }
          if (fromNo) {
            documentsArray = documentsArray.filter(item=> {
              let docId = keepOnlyNumbers(item.documentID);
              let fromNoDocId = keepOnlyNumbers(fromNo);
              let toNoDocId = keepOnlyNumbers(toNo);
              if (toNo) {
                 toNoDocId = keepOnlyNumbers(toNo);
              } else {
                 toNoDocId = keepOnlyNumbers(fromNo);
              }
              return docId >= fromNoDocId && docId <= toNoDocId;
            })
          }
          if (fillingStatus) {
            // TODO: Implement filter by filling status
            documentsArray = documentsArray.filter(item => item.taxWHFilingStatus === fillingStatus.id);
          }

          const orderBySelected = this.state.thaismartTaxPND54.orderBySelect;
          if (orderBySelected.key && orderBySelected.key !== "ID") {
            documentsArray.sort((a, b) => {
                if (a[orderBySelected.key] > b[orderBySelected.key]) {
                    return orderBySelected.value === "asc" ? 1 : -1;
                }
                if (a[orderBySelected.key] < b[orderBySelected.key]) {
                    return orderBySelected.value === "asc" ? -1 : 1;
                }
                return 0;
            })
          }

          const { list, page, orderBySelect } = this.state.thaismartTaxPND54;
          const startVisible = documents.docs[0];
          const lastVisible = documents.docs[documents.docs.length - 1];
          const stackPage = _.cloneDeep(this.state.thaismartTaxPND54.stackPage);
          stackPage[page] = { first: _.cloneDeep(startVisible), last: _.cloneDeep(lastVisible) };

          const downloaded = valueFilterList.includes("@DownloadedXml");
          const notDownload = valueFilterList.includes("not-download");

          if (downloaded && !notDownload && (keyword || (fromDate && toDate))) {
            documentsArray = list.filter(item => item["@DownloadedXml"]);
          } else if (notDownload && !downloaded && (keyword || (fromDate && toDate))) {
            documentsArray = list.filter(item => !item["@DownloadedXml"]);
          }

          commit("setStackPage", stackPage);
          if (page > 1 && (keyword || fromDate)) {
            commit("setCompaniesDocs", sortByField([...list, ...documentsArray], orderBySelect.key, orderBySelect.value));
          } else {
            commit("setCompaniesDocs", documentsArray);
          }
          commit("setListOrigin", documentsArray);
          commit("setEmptyList", false);
        } else if (documents.size === 0 && (keyword || fromDate || toDate) && page > 1) {
          commit("setCompaniesDocs", removeDuplicatesWithSameId(this.state.thaismartTaxPND54.list));
          commit("setListOrigin", []);
        } else {
          commit("setCompaniesDocs", []);
          commit("setListOrigin", []);
          commit("setEmptyList", true);
        }
        commit("setLoading", false);
      }, { source: "thaismartTaxPND54/getList" });
    },
    getDocListUnsubscribe() {
      if (this.state.mThaiSmartTaxDocListUnsubscribeObject) {
        this.state.mThaiSmartTaxDocListUnsubscribeObject();
        this.state.mThaiSmartTaxDocListUnsubscribeObject = null;
      }
    },

    updatePage({ commit }, { page }) { commit("setPage", page); },
    updateKeyword({ commit }, { keyword }) { commit("setKeyword", keyword); },
    resetKeyword({ commit }) { commit("setKeyword", ""); },
    setOrderBySelect({ commit }, { orderBySelect }) { commit("setOrderBySelect", orderBySelect); },
    setValueFilterList({ commit }, { valueFilterList }) { commit("setValueFilterList", valueFilterList); },
    setSelectedList({ commit }, { selectedList }) { commit("setSelectedList", selectedList); },
    getSummaryAll({ commit }, { companyId }) {
      if (this.state.mThaiSmartTaxSummaryAllUnsubscribeObject) {
        this.state.mThaiSmartTaxSummaryAllUnsubscribeObject();
      }
      this.state.mThaiSmartTaxSummaryAllUnsubscribeObject = fc.companies
        .doc(companyId)
        .collection("Summaries")
        .doc("all")
        .onSnapshot(allSummaries => {
          commit("setSummaryAll", allSummaries.data());
        });
    },
    getSummaryAllUnsubscribe() {
      if (this.state.mThaiSmartTaxSummaryAllUnsubscribeObject) {
        this.state.mThaiSmartTaxSummaryAllUnsubscribeObject();
        this.state.mThaiSmartTaxSummaryAllUnsubscribeObject = null;
      }
    },
    setShowPaginationTemplate({ commit }, { val }) { commit("setShowPaginationTemplate", val); },

    async fetchTimePeriods({ commit }, { companyId , year }) {
      commit("setLoading", true);

      try {
        const end = firebase.firestore.Timestamp.fromDate(new Date(`${year}-12-31T23:59:59Z`));
        //const end = firebase.firestore.Timestamp.fromDate(new Date(Date.UTC(year + 1, 0, 0, 23, 59, 59)));
        //console.log("🚀 ~ fetchTimePeriods ~ end:", end)
        const query = fc.companies
        .doc(companyId)
        .collection("SettingThaiSmartTax")
        .doc("taxTimePeriods")
        .collection("TimePeriods")
          // .where('type', '==', 'year')
          // .where('startDate', '>=', start)
        .where('endDate', '<=', end);

        const snapshot = await query.get();

        const timePeriods = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
       // console.log(JSON.stringify(timePeriods))

        commit("setTimePeriods", timePeriods);
        commit("setLoading", false);

       // return timePeriods;
      } catch (error) {
        console.error("Error fetching time periods: ", error);
        commit("setLoading", false);
      }
    },
    async getBranchList({ commit },{companyId}) {
      commit("setLoading", true);

      try {
        const docRef = fc.companies
          .doc(companyId)
          .collection("SettingThaiSmartTax")
          .doc("taxBranch");

        const docSnapshot = await docRef.get();

        if (docSnapshot.exists) {
          const branchData = {
            id: docSnapshot.id,
            ...docSnapshot.data()
          };
          //console.log("Fetched branch data:", branchData);
          commit("setBranchList", branchData);
        } else {
          console.log("No taxWHBranch document found!");
          commit("setBranchList", []);
        }

        commit("setLoading", false);
      } catch (error) {
        commit("setLoading", false);
      }
    },

    async fetchTaxWHBranch({ commit }, { companyId }) {
      commit("setLoading", true);
      console.log ("companyId",companyId)

      try {
        const docRef = fc.companies
          .doc(companyId)
          .collection("SettingThaiSmartTax")
          .doc("taxBranch");

        const docSnapshot = await docRef.get();

        if (docSnapshot.exists) {
          const branchData = {
            id: docSnapshot.id,
            ...docSnapshot.data(),
            branch : docSnapshot.data().branch?.map((a)=>({
              ...a,
              disable : false
            }))


          };
          //console.log("Fetched branch data:", branchData);
          commit("setTaxWHBranch", branchData);
          console.log("branchData",branchData)
        } else {
          console.log("No taxWHBranch document found!");
          commit("setTaxWHBranch", []);
        }

        commit("setLoading", false);
      } catch (error) {
        commit("setLoading", false);
      }
    },



    async fetchTaxTimePeriods({ commit }, { companyId }) {
      commit("setLoading", true);

      try {
        const docRef = fc.companies
          .doc(companyId)
          .collection("SettingThaiSmartTax")
          .doc("taxBranch");

        const docSnapshot = await docRef.get();

        if (docSnapshot.exists) {
          const branchData = {
            id: docSnapshot.id,
            ...docSnapshot.data()
          };
          //console.log("Fetched branch data:", branchData);
          commit("setTaxTimePeriods", branchData);
        } else {
          console.log("No TaxTimePeriods document found!");
          commit("setTaxTimePeriods", []);
        }

        commit("setLoading", false);
      } catch (error) {
        commit("setLoading", false);
      }
    },

    async fetchTimePeriodsByYear({ commit }, { companyId, yearId }) {
      commit("setLoading", true);

      try {
        const yearDoc = await fc.companies
          .doc(companyId)
          .collection("SettingThaiSmartTax")
          .doc("taxTimePeriods")
          .collection("TimePeriods")
          .doc(yearId)
          .get();

        if (yearDoc.exists) {
         // console.log(`Year: ${yearDoc.id}`, yearDoc.data());

          const quarterQuery = await fc.companies
            .doc(companyId)
            .collection("SettingThaiSmartTax")
            .doc("taxTimePeriods")
            .collection("TimePeriods")
            .where('parentIndex', '==', yearDoc.id)
            .where('type', '==', 'quarter')
            .get();

          const quarters = [];
          const quarterPromises = quarterQuery.docs.map(async (quarterDoc) => {
            //console.log(`Quarter: ${quarterDoc.id}`, quarterDoc.data());

            const monthQuery = await fc.companies
              .doc(companyId)
              .collection("SettingThaiSmartTax")
              .doc("taxTimePeriods")
              .collection("TimePeriods")
              .where('parentIndex', '==', quarterDoc.id)
              .where('type', '==', 'month')
              .get();

            const months = monthQuery.docs.map(monthDoc => ({
              id: monthDoc.id,
              ...monthDoc.data(),
            }));

            quarters.push({
              id: quarterDoc.id,
              ...quarterDoc.data(),
              months,
            });
          });

          await Promise.all(quarterPromises);

          commit("setTimePeriodsYear", { yearId: yearDoc.id, quarters });
        } else {
          console.warn(`No year document found with ID: ${yearId}`);
          commit("setTimePeriodsYear", []);
        }
      } catch (error) {
        console.error("Error fetching time periods by year:", error);
      } finally {
        commit("setLoading", false);
      }
    },
    async fetchDocsThaiSm({ commit }, { companyId, taxWHCode, startDate, endDate, subsidiariesBranch }) {
      commit('setLoading', true);

      try {
        if (!companyId) {
          throw new Error('Company ID is required');
        }

        const docsThaiSmRef = fc.companies.doc(companyId).collection('DocsThaiSmartTax');

        let query = docsThaiSmRef;
           // query = query.where('transactionStatus', '==', 'Cancel');
        if (taxWHCode) {
          query = query.where('taxWHCode', '==', taxWHCode);
        }

        if (startDate) {
          query = query.where('docDate', '>=', startDate);
        }

        if (endDate) {
         // console.log("🚀 ~ fetchDocsThaiSm ~ endDate:", endDate)
          query = query.where('docDate', '<=', endDate);
        }

        if (subsidiariesBranch) {
          query = query.where('subsidiariesBranch', '==', subsidiariesBranch);
        }

        const querySnapshot = await query.get();

        if (querySnapshot.empty) {
          console.log('No matching documents found');
          commit('setDocsThaiSm', []);
          return;
        }

        const documents = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        })).filter(doc => doc.transactionStatus !== 'Cancel');

       //console.log("Fetched documents:", documents);

        commit('setDocsThaiSm', documents);
       // return documents;
      } catch (error) {
        console.error('Error fetching documents:', error);
        throw error;
      } finally {
        commit('setLoading', false);
      }
    },

    async updateThaiSmartTax({ commit }, { companyId, data }) {
      try {

        if (!companyId || !data?.docID) {
          console.error('companyId or docId is missing or invalid.');
          commit('setLoading', false);
          return;
        }

        commit('setLoading', true);

        const docsThaiSmRef = fc.companies.doc(companyId).collection('DocsThaiSmartTax');

        const docID = data.docID;

        let pdfCount = data.pdfCount || 0
        let printCount = data.printCount || 0
        const updateData = {}
        if(data.type === 'download'){
          updateData["@DownloadedPdfCount"] = pdfCount
        }
        if(data.type === 'print'){
          updateData["@PrintedPdfCount"] = printCount
        }
        if(!updateData){
          console.log('data is missing .');
          commit('setLoading', false);
          return;
        }
       // console.table(updateData)

        await docsThaiSmRef.doc(docID).set(updateData, { merge: true });

        commit('setLoading', false);

        //console.log('Document successfully updated with merge:', docID);

      } catch (error) {
        // Handle error
        console.error('Error updating Thai Smart Tax:', error);

        // Reset loading state on error
        commit('setLoading', false);
      }
    },

    setFilterData({ commit }, val ) { commit("setFilterData", val); },

    async cancelSelectedDoc({ rootState }, { companyId }) {
      const selectedList = rootState.thaismartTaxPND54.selectedList;
      const docsRef = fc.companies.doc(companyId).collection("DocsThaiSmartTax");
      const batch = fc.db.batch();
      for (const item of selectedList) {
        if (!item.docID) continue;
        batch.update(docsRef.doc(item.docID), { transactionStatus: "Cancel" });
      }
      await batch.commit();
    },
  },
};
